// ======================================================================
// File Name       : ContentLinkCourseList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, InputGroup, Col, Row, Button, Table, FormControl } from 'react-bootstrap';
import ReduxFormPaging from '../../ReduxFormPaging';


class ContentLinkCourseList extends Component {

  render() {
    const { targetContent, addedContentList, checkedContentOnModal } = this.props;
    const { recordNum } = targetContent;
    const contentTypeArray = ['ビデオ', 'ドリル', '問題', 'ドキュメント', null, 'リンク'];
    const dataAffiliationType = ['内部', '外部'];

    return (
      <div>
        <Col sm={12} className="margin-top-10">
          <Col sm={2} className="margin-bottom-15">
            <Button variant="default" onClick={this.props.handleCheckAllBox}>全選択/解除</Button>
          </Col>
          <Col sm={10} className="d-flex justify-content-end">
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={this.props.getStartEndData}
            />
          </Col>
        </Col>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-1" />
              <th>コンテンツ名</th>
              <th>コンテンツ種別</th>
              <th>外部</th>
              <th>コース名</th>
              <th>セクション名</th>
            </tr>
          </thead>
          <tbody>
            { targetContent.allSecernIds.map((itemSecernId, index) => {
              const item = targetContent.bySecernId[itemSecernId];
              const checked = checkedContentOnModal.indexOf(itemSecernId) > -1;

              return (
                <tr key={index}>
                  <td>
                    <Form.Check
                      type='checkbox'
                      className="text-center margin-clear"
                      value={itemSecernId}
                      checked={!!addedContentList[itemSecernId] || checked}
                      disabled={!!addedContentList[itemSecernId]}
                      onChange={this.props.handleCheckbox} />
                  </td>
                  <td>{item.itemName}</td>
                  <td>{contentTypeArray[item.contentInfo.contentType]}</td>
                  <td>{dataAffiliationType[item.dataAffiliationType]}</td>
                  <td>{item.courseName}</td>
                  <td>{item.parentBoxName}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Col sm={12} className="text-center">
          <Button variant="primary" className="btn-96" onClick={this.props.handleAddContent}>
            追加
          </Button>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { targetContent, addedContentList } = state.csvDownload;
  return { targetContent, addedContentList };
};
export default connect(mapStateToProps)(ContentLinkCourseList);

